import { findOrphanedTotpFactors, type MfaFactor } from "./mfaEnrollment";

export type ReplacementApi = Pick<
  typeof import("../api/mfaAuthClient").mfaClient.auth.mfa,
  "listFactors" | "unenroll" | "enroll" | "challenge" | "verify"
>;

export type ReplacementPreparation =
  | { kind: "ready"; factorId: string }
  | { kind: "error"; message: string };

export async function findCurrentFactor(api: ReplacementApi): Promise<ReplacementPreparation> {
  const { data, error } = await api.listFactors();
  if (error) return { kind: "error", message: "Não foi possível localizar seu autenticador agora. Tente novamente." };
  const factor = (data?.totp ?? []).find((candidate) => candidate.factor_type === "totp" && candidate.status === "verified");
  return factor
    ? { kind: "ready", factorId: factor.id }
    : { kind: "error", message: "Não há um autenticador TOTP verificado disponível para a troca." };
}

export type NewFactor = { id: string; qrCode: string; secret: string };

async function removeOrphanedFactors(api: ReplacementApi, factors: unknown): Promise<void> {
  for (const factor of findOrphanedTotpFactors((factors ?? []) as MfaFactor[])) {
    const { error } = await api.unenroll({ factorId: factor.id });
    if (error) throw error;
  }
}

export async function replaceFactor(api: ReplacementApi): Promise<NewFactor> {
  const { data: factorData, error: factorsError } = await api.listFactors();
  if (factorsError) throw factorsError;
  await removeOrphanedFactors(api, factorData?.all);

  const { data, error: enrollError } = await api.enroll({ factorType: "totp", friendlyName: "Novo autenticador" });
  if (enrollError || !data?.id || !data.totp?.qr_code || !data.totp.secret) {
    throw new Error("Não foi possível preparar o novo autenticador. Tente novamente.");
  }

  return { id: data.id, qrCode: data.totp.qr_code, secret: data.totp.secret };
}
